import { Paper, Typography } from "@mui/material";
import classes from "./jaa.module.css";

import { useKeikkaData } from "src/context/KeikkaDataContext";
import { showKalleUrhoOyToiminnot } from "src/data/ifs/showIfs";
import { lazy } from "react";

import MyDivider from "src/components/layout/MyDivider";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const SendBetoniTilausButton = lazy(() =>
  import(
    "src/components/comms/SendBetonitilausToBetoniToimittajaButton/SendBetonitilausToBetoniToimittajaButton"
  )
);
const SendSMSButton = lazy(() => import("src/components/comms/SendSMSButton/SendSMSButton"));
const SendNotificationsButton = lazy(() =>
  import("src/components/comms/SendNotificationsButton/SendNotificationsButton")
);

const SendTilausVahvistusButton = lazy(() =>
  import("src/components/comms/SendTilausVahvistusButton/SendTilausVahvistusButton")
);
const RefreshPumiFiKeikkaButton = lazy(() =>
  import("src/pages/pumi.fi/components/RefreshPumiFiKeikkaButton/RefreshPumiFiKeikkaButton")
);
const CreatePumiFiPalkkiButton = lazy(() =>
  import("src/pages/pumi.fi/components/CreatePumiFiPalkkiButton/CreatePumiFiPalkkiButton")
);
const SendKapasiteettiMuutosButton = lazy(() =>
  import("src/pages/pumi.fi/components/SendKapasiteettiMuutosButton/SendKapasiteettiMuutosButton")
);
export default function Jaa() {
  const { keikkaData, reloadKeikkaData } = useKeikkaData();

  return (
    <>
      <MyDivider gutter>Lähetä tilaustiedot</MyDivider>
      <div className={classes.row2}>
        <LazyLoader txt={"Ladataan"}>
          <div style={{ width: "50%" }}>
            <SendTilausVahvistusButton
              show={keikkaData.isLoading}
              keikkaData={keikkaData}
              txt="Lähetä tilausvahvistus asiakkaalle"
              fullWidth
            />
          </div>
          {import.meta.env.ENABLE_SMS === "yes" && (
            <div style={{ width: "40%" }}>
              <SendSMSButton keikkaData={keikkaData} txt="Lähetä tekstiviesti" fullWidth />
            </div>
          )}
        </LazyLoader>
      </div>
      <div className={classes.row} style={{ display: "none" }}>
        <Typography color="primary">Lähetä ilmoituksia</Typography>
        <SendNotificationsButton keikkaData={keikkaData} />
      </div>
      {showKalleUrhoOyToiminnot(keikkaData) && (
        <Paper elevation={3} sx={{ margin: "10px", padding: "10px" }}>
          <LazyLoader txt={"Ladataan"}>
            <MyDivider gutter>Kalle Urho Oy toiminnot</MyDivider>
            <div className={classes.row}>
              <RefreshPumiFiKeikkaButton
                disabled={keikkaData.foreignKey == null}
                reloadKeikkaData={reloadKeikkaData}
                fullWidth
                buttonText="Tuo tilaus uudestaan pumi.fi:stä (FULL)"
              />
            </div>
            <div className={classes.row}>
              <RefreshPumiFiKeikkaButton
                disabled={keikkaData.foreignKey == null}
                reloadKeikkaData={reloadKeikkaData}
                fullWidth
                buttonText="Tuo tilaus uudestaan pumi.fi:stä (quicksync)"
                quickSync
              />
            </div>
            <div className={classes.row}>
              <CreatePumiFiPalkkiButton
                keikkaData={keikkaData}
                fullWidth
                buttonText="Luo pumi.fi palkki"
              />
            </div>
            <div className={classes.row}>
              <SendBetoniTilausButton
                show={keikkaData.isLoading}
                keikkaData={keikkaData}
                fullWidth
                buttonText={
                  "Lähetä betonitilaus betonivalmistajalle " +
                  keikkaData.betoniToimittaja.asiakasNimi
                }
              />
            </div>
            <div className={classes.row}>
              <SendKapasiteettiMuutosButton
                keikkaData={keikkaData}
                fullWidth
                buttonText="Lähetä kapasiteetti muutos"
              />
            </div>
          </LazyLoader>
        </Paper>
      )}
    </>
  );
}
